import { render } from "./talentpolicy.vue?vue&type=template&id=59ab457c&scoped=true"
import script from "./talentpolicy.vue?vue&type=script&lang=js"
export * from "./talentpolicy.vue?vue&type=script&lang=js"

import "./talentpolicy.vue?vue&type=style&index=0&id=59ab457c&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59ab457c"]])

export default __exports__